import React, { useState } from 'react';
import './employerform1.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate , Link } from 'react-router-dom';
import { Container, Form, Button, Row, Col, Image } from 'react-bootstrap';
import bar01 from '../../../images/bar01.svg';


function Employerform1() {
  const [companyName, setCompanyName] = useState('');
  const [country, setCountry] = useState('');
  const [telephone, setTelephone] = useState('');
  const [website, setWebsite] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(`Company Name: ${companyName}, Country: ${country}, Telephone: ${telephone}, Website: ${website}`);
  };

  return (
    <Container fluid className='p-0 m-0'>
      <div className='d-flex align-items-center text-center  gap-4 py-5 px-3'>
      <FaArrowLeft className='arrow' onClick={() => navigate("/employersignup")} />
      <h3 className='mt-4'>Back</h3>
      </div>
      <Container fluid className='p-3 p-sm-5' style={{ background: 'rgba(255, 161, 94, 0.55)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
        <div className='d-block align-items-center justify-content-center text-center py-3'>
        <Image fluid src={bar01} alt='bar' />
        <h2 className='form-head mt-4'>Company Details</h2>
        </div>
        <Form onSubmit={handleSubmit} className='mt-5' >
        <Row className='gap-0 gap-sm-5 mt-4'>
          <Col xs={12} sm={true}>
          <Form.Group controlId="companyName" className='mb-4'>
                <Form.Label className='form-text-label'>Company Name</Form.Label>
                <Form.Control type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} placeholder="Enter company name" style={{border: '1px solid #005EB5',
               borderRadius: '60px'}} className='py-2'/>
          </Form.Group>
          <Form.Group controlId="telephone" className='mb-4'>
                <Form.Label className='form-text-label'>Telephone</Form.Label>
                <Form.Control type="text" value={telephone} onChange={(e) => setTelephone(e.target.value)} placeholder="Enter telephone" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2' />
          </Form.Group>
          </Col>
          <Col xs={12} sm={true}>
          <Form.Group controlId="country" className='mb-4'>
                <Form.Label className='form-text-label'>Country</Form.Label>
                <Form.Control type="text" value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Enter country" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2'/>
          </Form.Group>
          <Form.Group controlId="website" className='mb-4'>
                <Form.Label className='form-text-label'>Company Website</Form.Label>
                <Form.Control type="text" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="Enter company website" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2'/>
              </Form.Group>
          </Col>
        </Row>
        <div className='mt-3 d-flex text-center justify-content-center align-items-center mx-3'> 
        <Link to="/employerform2" className='next-button'>Next
          </Link>
        </div>
        </Form>

      </Container>
   
    </Container>
  );
}

export default Employerform1;
